import { Component, signal, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    imports: [TranslateModule]
})
export class FooterComponent {
    protected year: Signal<number> = signal<number>(new Date().getFullYear());
    protected links: Signal<{ name: string; url: string }[]> = signal([
        { name: 'corporate-information', url: 'https://www.siemens-healthineers.com/corporate-info' },
        { name: 'privacy-policy', url: 'https://www.siemens-healthineers.com/siemens-website-privacy-policy' },
        { name: 'terms-of-use', url: 'https://www.siemens-healthineers.com/terms-of-use' }
    ]);
}
